import { render, staticRenderFns } from "./CompanyBalance.vue?vue&type=template&id=d124215e&"
import script from "./CompanyBalance.vue?vue&type=script&lang=ts&"
export * from "./CompanyBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports